import React, { useCallback, useRef, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

import api from '../../../utils/functions/api';
import { formatEmployeeThaiName } from '../../../utils/functions/employeeName';

const PAGE_SIZE = 50;

// ค้นหา/เลือกพนักงานแบบ paginate + search-as-you-type — โมเดลตาม EmployeeAutocomplete ใน
// HrExpenseApproverSettings.js (เอาแค่ logic มาปรับ ไม่ได้แยก component ใช้ร่วมกันเพราะอยู่คนละ module)
export default function EmployeeAutocomplete({ value, onChange, placeholder }) {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const searchTimer = useRef(null);
  const hasMore = rows.length < total;

  const load = useCallback(async (p, q, reset) => {
    setLoading(true);
    try {
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/employee?name=${q}&size=${PAGE_SIZE}&page=${p}`
      );
      if (status === 200) {
        setTotal(data?.total || 0);
        setRows((prev) => (reset ? data?.rows || [] : [...prev, ...(data?.rows || [])]));
        setPage(p);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const handleInputChange = (event, inputValue, reason) => {
    if (reason !== 'input') {
      return;
    }
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    searchTimer.current = setTimeout(() => load(1, inputValue, true), 300);
  };

  const handleOpen = () => {
    if (rows.length === 0) {
      load(1, '', true);
    }
  };

  const handleScroll = (event) => {
    const el = event.target;
    if (hasMore && !loading && el.scrollTop + el.clientHeight >= el.scrollHeight - 24) {
      load(page + 1, '', false);
    }
  };

  return (
    <Autocomplete
      value={value}
      options={rows}
      getOptionLabel={(o) => {
        if (typeof o === 'string') {
          return o;
        }
        return `${formatEmployeeThaiName(o)} (${o?.employee_id || ''})`;
      }}
      isOptionEqualToValue={(o, v) => o?._id === v?._id}
      onChange={(event, v) => onChange(v)}
      onOpen={handleOpen}
      filterOptions={(x) => x}
      onInputChange={handleInputChange}
      loading={loading}
      ListboxProps={{ onScroll: handleScroll, style: { maxHeight: 280 } }}
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder={placeholder} label="พนักงาน" />
      )}
    />
  );
}
